import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BB_COURSE_PROGRAM_IDS, LLTTF_PROGRAM_IDS } from 'src/app/components/authorize/admin-program-mode';
import { CourseList, CourseListDefaultValues, CourseQueryFilter, CourseQueryFilterDefaultValues } from 'src/app/components/course/course-list';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { AuthService } from 'src/app/services/auth.service';
import { CourseService } from 'src/app/services/course.service';
import { TagsService } from 'src/app/services/tag-service.service';

@Component({
    selector: 'app-course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.scss'],
    standalone: false
})
export class CourseListComponent {
  courseList: CourseList[] = [];
  totalRecords: number = 0;
  columnsToDisplay = [
    'name',
    'id',
    'program',
    'enrollment',
    'status',
  ];
  //queryFilter: TagQueryFilter = TagQueryFilterDefaultValues();
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef;
  information: string = '';
  queryFilter: CourseQueryFilter = CourseQueryFilterDefaultValues();
  tags: any[] = [];
  coursePrograms: any[] = [];
  courseStatus: any[] = [];
  pageName = CheckPageAccess.COURSES
  showaddbutton = this.authservice.getAccessControl().addCourse;

  constructor(public courseservice: CourseService,
    private tagservice: TagsService,
    private appprogservice: ApplicationProgramsService,
    private authservice: AuthService) {
  }

  async ngOnInit(): Promise<void> {
    this.information="<h4>Status Definitions</h4>"+
    "<br/><span>Draft:</span> Course is in progress and not yet finalized. It can be edited and is not visible to participants.<br/><br/>"+
    "<span>Published:</span> Course is active and available for use by participants. It can be edited so long as it has zero enrolments.<br/><br/>"+
    "<span>Retired:</span> Course is no longer actively used for new participants but remains accessible to users who started using it while it was in the published status. It cannot be edited.";

    this.applyProgramModeToFilter();

    await this.appprogservice.getCoursePrograms().subscribe({
      next: (data) => {
        this.coursePrograms = this.filterProgramsByMode(data);
      }
    });

    await this.tagservice.getActiveTags().subscribe({
      next: (data) => {
        this.tags = data;
      }
    });

    await this.courseservice.getCourseStatus().subscribe({
      next:(resp )=> {
        this.courseStatus = resp;
      }
    });

    this.searchWithFilters();
  }

  private applyProgramModeToFilter() {
    this.queryFilter.ProgramMode = this.authservice.getEffectiveProgramMode();
  }

  private filterProgramsByMode(programs: any[]): any[] {
    const mode = this.authservice.getEffectiveProgramMode();
    // BB mode keeps LLTTF Adult-Materials available for materials/courses
    const programIds = mode === 'llttf' ? LLTTF_PROGRAM_IDS : BB_COURSE_PROGRAM_IDS;
    return programs.filter((p: any) => programIds.includes(p.id));
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex;
    this.queryFilter.PageSize = e.pageSize;
    this.searchWithFilters();
  }

  private searchWithFilters() {
    this.applyProgramModeToFilter();
    this.courseservice.getAllCourses(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }

        this.courseList = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
      this.submitButton.nativeElement.click();
      event.preventDefault();
	  }
	}

  resetFilters() {
    this.queryFilter = CourseQueryFilterDefaultValues();
    this.applyProgramModeToFilter();
    this.search();
  }

  search() {
    this.searchWithFilters();
  }
}
